import {
    InternalEmailLayout,
    dominioIntegrationRow,
    requesterSection
} from "../../../shared/email/internal-email-layout";

/**
 * E-mail interno "Quero mudar de plano" — disparado pelo usuário logado da
 * contabilidade (botão de upgrade / menu do perfil).
 *
 * @param {object} params
 * @param {{name, superLogicaId, hubspotId, contract}} params.accounting
 * @param {{name, phone, email}} params.requester  usuário logado
 */
export const TemplateRequestContract = ({ accounting = {}, requester = {} }) =>
    InternalEmailLayout({
        eyebrow: "Quero mudar de plano",
        title: `(${accounting.superLogicaId ?? "-"}) ${accounting.name ?? "-"}`,
        intro: "Um usuário da contabilidade pediu para mudar de plano.",
        sections: [
            requesterSection(requester),
            {
                title: "Contrato atual",
                rows: [["Plano atual", accounting.contract]]
            },
            {
                title: "Dados da contabilidade",
                rows: [
                    ["Código da Nucont", accounting.superLogicaId],
                    ["Código no HubSpot", accounting.hubspotId],
                    dominioIntegrationRow(accounting.integrationsHealth)
                ]
            }
        ]
    });
